/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface PixPaymentAttempt {
  creditCardPaymentId?: number;
  dateCreated?: Date;
  dateScheduled?: Date;
  dateUpdated?: Date;
  e2e?: string;
  idRec?: string;
  pixPaymentAttemptId?: number;
  pixRecurrenceId?: number;
  status?: PixPaymentAttempt.StatusEnum;
  txid?: string;
  type?: PixPaymentAttempt.TypeEnum;
}
export namespace PixPaymentAttempt {
  export type StatusEnum =
    | 'AGENDADA'
    | 'PAGA'
    | 'CANCELADA'
    | 'REJEITADA'
    | 'EXPIRADA'
    | 'SOLICITADA';
  export const StatusEnum = {
    AGENDADA: 'AGENDADA' as StatusEnum,
    PAGA: 'PAGA' as StatusEnum,
    CANCELADA: 'CANCELADA' as StatusEnum,
    REJEITADA: 'REJEITADA' as StatusEnum,
    EXPIRADA: 'EXPIRADA' as StatusEnum,
    SOLICITADA: 'SOLICITADA' as StatusEnum
  };
  export type TypeEnum = 'AGND' | 'NTAG' | 'RIFL';
  export const TypeEnum = {
    AGND: 'AGND' as TypeEnum,
    NTAG: 'NTAG' as TypeEnum,
    RIFL: 'RIFL' as TypeEnum
  };
}
